<template>
<div class="chapter">
<div class="inner_page">
<section epub:type="toc" id="_idContainer002" role="doc-toc">
<p class="TOCtitle">Table of Contents</p>
<p class="TOCitem"><a href="#/Texas_Cinderella#_idTextAnchor001">Texas Cinderella</a> by Winnie Griggs</p>
<p class="TOCitem"><span href="#/Would_Be_Wilderness_Wife#_idTextAnchor031" title="Link target outside of Sample">Would-Be Wilderness Wife</span> by Regina Scott</p>
<p class="TOCitem">Excerpt from <span href="#/Excerpt#_idTextAnchor056" title="Link target outside of Sample">Her Easter Prayer</span> by Lee Tobin McClain</p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Table_of_Contents.vue?9f7a6fd8